<template>
  <div class="white-container full-page-container common-table">
    <el-button
      size="small"
      type="primary"
      icon="el-icon-plus"
      style="position: absolute; top: -50px; right: 0"
      @click="add"
    >新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item class="search-form-item" label="开奖标题">
        <el-input
          v-model="search.lotteryTitle"
          placeholder="输入开奖标题"
          prefix-icon="el-icon-search"
        />
      </el-form-item>
      <el-form-item class="search-form-item" label="关联活动">
        <el-input
          v-model="search.eventName"
          placeholder="输入活动标题"
          prefix-icon="el-icon-search"
        />
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          ref="statusBox"
          v-model="search.status"
          placeholder="选择活动状态"
        >
          <el-option label="所有" value="" />
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="activity-table">
      <tableList
        ref="multipleTable"
        size="small"
        :table-query="search"
        :query-function="$Api.lottery.postLotteryList"
        style="width: 100%"
      >
        <el-table-column prop="id" label="活动ID" />

        <el-table-column prop="lotteryTitle" label="开奖标题" width="auto" />

        <el-table-column prop="eventName" label="关联活动" min-width="160">
          <template v-slot="{ row }">
            <span>{{ row.eventName || "--" }} </span>
            <span v-if="row.objectId">(ID {{ row.objectId }})
              <span v-if="row.goal" class="red">(goal {{ row.goal }})</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="prizeInformationListVOS"
          label="奖品"
          min-width="160"
        >
          <template v-slot="scope">
            <template
              v-if="
                scope.row.prizeInformationListVOS &&
                  scope.row.prizeInformationListVOS.length
              "
            >
              <div
                v-for="(item, index) in scope.row.prizeInformationListVOS"
                :key="item.prizeName + index"
              >
                <span>{{ item.prizeName }} </span>
                <span>{{ item.prizeNum }}名</span>
              </div>
            </template>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          label="状态"
          width="auto"
          min-width="120"
          align="center"
        >
          <template v-slot="scope">
            <el-tag
              v-if="scope.row.status === 0"
              class="el-tag--blue"
              size="mini"
            >关联活动进行中</el-tag>
            <el-tag
              v-if="scope.row.status === 1"
              class="el-tag--red"
              size="mini"
            >待开奖</el-tag>
            <el-tag
              v-if="scope.row.status === 2"
              class="el-tag--yellow"
              size="mini"
            >待公示</el-tag>
            <el-tag
              v-if="scope.row.status === 3"
              class="el-tag--purple"
              size="mini"
            >已公示</el-tag>
            <el-tag
              v-if="scope.row.status === 4"
              class="el-tag--gray"
              size="mini"
            >关联活动已删除</el-tag>
            <el-tag
              v-if="![0, 1, 2, 3, 4].includes(scope.row.status)"
              class="el-tag--gray"
              size="mini"
            >--</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="lastControlsTime"
          label="最后操作时间"
          width="150px"
        >
          <template v-slot="{ row }">
            {{ formatTime(row.lastControlsTime) }}
          </template>
        </el-table-column>

        <el-table-column fixed="right" width="280px" label="操作">
          <template v-slot="{ row }">
            <el-button
              v-if="row.status === 0 || row.status === 4"
              size="small"
              type="text"
              class="link-color"
              @click="edit(row)"
            >编辑</el-button>
            <el-button
              v-if="row.status === 1"
              size="small"
              type="text"
              class="link-color"
              @click="runALottery(row)"
            >开奖</el-button>
            <el-button
              v-if="row.status === 2"
              size="small"
              type="text"
              class="link-color"
              @click="publicityList(row.id)"
            >公示获奖名单</el-button>
            <el-button
              v-if="row.status === 2 || row.status === 3"
              size="small"
              type="text"
              class="link-color"
              @click="searchResult(row.id)"
            >查看获奖名单</el-button>
            <el-button
              v-if="row.status === 4"
              size="small"
              type="text"
              class="link-color"
              @click="remove(row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </tableList>
      <Dialog
        v-if="formDialogShow"
        v-model="formDialogShow"
        :information="information"
        @submit-success="submitSuccess"
      />
      <!-- 公示二次确认弹窗 -->
      <Dialog
        v-if="publishShow"
        v-model="publishShow"
        title="确认要公示获奖名单"
        :information="publishObj"
        cancel-text="暂不公示"
        confirm-text="确认公示"
        @submit-success="publishConfirm"
      />
      <!-- 抽奖弹窗 -->
      <el-dialog
        v-if="importDialogShow"
        :visible="importDialogShow"
        title="开奖"
        custom-class="share-wrapper"
        @close="handleCloseImport"
      >
        <div class="lottery-top" style="display: flex">
          <div>获得抽奖资格人数：{{ lotteryForm.personNum }}</div>
          <div>抽奖码数：{{ lotteryForm.codeNum }}</div>
        </div>
        <div class="lottery-box">
          <el-form
            ref="lotteryForm"
            class="lottery-form"
            :rules="lotteryFormRules"
            :model="lotteryForm"
            size="small"
          >
            <el-form-item label="兑奖有效期" prop="exportTime">
              <el-date-picker
                v-model="lotteryForm.exportTime"
                type="datetimerange"
                range-separator="-"
                start-placeholder="兑奖开始日期和时间"
                end-placeholder="兑奖结束日期和时间"
                class="lottery-time"
                prefix-icon="el-icon-date"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleFormatExportTime"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="flex btns">
          <el-button type="info" @click="handleCloseImport">取消</el-button>
          <el-button type="primary" class="submitBtn" @click="uploadSubmit">确认开奖</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import tableList from "@/components/TableList";
import Dialog from "@/components/Dialog";
import { formatDateTime } from "@/filters";
const statusList = [
  { id: 0, value: "关联活动进行中", color: "warning" },
  { id: 1, value: "待开奖", color: "warning" },
  { id: 2, value: "待公示", color: "warning" },
  { id: 3, value: "已公示", color: "warning" },
  { id: 4, value: "关联活动已删除", color: "warning" },
];
// 0关联活动进行中，1待抽奖，2待公示，3已公示,4关联活动已删除
export default {
  components: { tableList, Dialog },
  data() {
    return {
      statusList,
      search: {
        lotteryTitle: "",
        eventName: "",
        status: "",
      },
      formDialogShow: false,
      currentID: -1,
      information: {},
      lotteryForm: {},
      lotteryFormRules: {
        exportTime: [
          {
            type: "array",
            required: true,
            message: "请选择兑奖有效期",
            trigger: ["change", "blur"],
          },
        ],
      },
      importDialogShow: false,
      exportTimes: {
        prizeBeginTime: "",
        prizeEndTime: "",
      },
      publishShow: false,
      publishObj: {},
    };
  },
  methods: {
    formatTime(val) {
      if (val) return moment(val).format("YYYY.MM.DD HH:mm:ss");
      return "";
    },
    add() {
      this.$router.push({ path: "/lottery/add" });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: "edit",
        icon: "warn",
        subTitle: `是否确认编辑内容ID为“${row.id}”的数据项？`,
      };
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: "copy",
        icon: "success",
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    // 公示获奖名单
    publicityList(id) {
      this.publishShow = true;
      this.currentID = id;
      this.publishObj = {
        operation: "confirm",
        icon: "warn",
        subTitle: "公示后，获奖名单信息将在前端显示",
      };
    },
    searchResult(id) {
      this.$Api.lottery.lotteryDownload(id).then(res => {
        this.$message.success("下载成功");
        this.$refs["multipleTable"].getTableList();
      });
    },
    remove(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: "delete",
        icon: "warn",
        subTitle: "请确认是否删除",
      };
    },
    publishConfirm(operation) {
      if (operation === "confirm") {
        this.$Api.lottery
          .publiclyLottery(this.currentID)
          .then(() => {
            this.publishShow = false;
            this.$message.success("公示成功");
            this.$refs["multipleTable"].getTableList();
          })
          .catch(error => {
            this.publishShow = true;
            this.publishObj = {
              operation: "error",
              icon: "error",
              subTitle: `${error.errorMessage}`,
            };
          });
      }
      console.log("operation", operation);
    },
    submitSuccess(operation) {
      if (operation === "delete") {
        this.$Api.lottery
          .delLottery(this.currentID)
          .then(() => {
            this.formDialogShow = false;
            this.$message.success("删除成功");
            this.$refs["multipleTable"].getTableList();
          })
          .catch(error => {
            this.formDialogShow = true;
            this.information = {
              operation: "error",
              icon: "error",
              subTitle: `${error.errorMessage}`,
            };
          });
      } else if (operation === "copy") {
        this.$router.push({
          path: "/lottery/add",
          query: { copyid: this.currentID },
        });
      } else if (operation === "edit") {
        this.$router.push({
          path: "/lottery/edit",
          query: { id: this.currentID },
        });
      }
    },

    searchSubmit() {
      this.$refs["multipleTable"].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs["multipleTable"].searchAndReset();
      });
    },
    // 开奖
    runALottery(row) {
      this.importDialogShow = true;
      this.currentID = row.id;
      this.lotteryForm = row;
    },
    handleCloseImport() {
      this.importDialogShow = false;
      this.lotteryForm = {};
    },
    // 处理导出时间
    handleFormatExportTime(val) {
      this.exportTimes = {
        prizeBeginTime: "",
        prizeEndTime: "",
      };
      if (val && val.length) {
        this.exportTimes = {
          prizeBeginTime: formatDateTime(val[0]),
          prizeEndTime: formatDateTime(val[1]),
        };
      }
    },
    // 确认抽奖
    uploadSubmit() {
      const { id, personNum, codeNum } = this.lotteryForm;
      if (!id) return;
      console.log(personNum, codeNum);
      this.$refs.lotteryForm.validate(valid => {
        if (valid) {
          if (personNum === 0) {
            return this.$message.error("没有人完成活动不可抽奖");
          }
          this.$Api.lottery
            .lotteryUserLottery({ ...this.exportTimes, id: this.currentID })
            .then(res => {
              this.$message.success("开奖成功");
              this.$refs["multipleTable"].getTableList();
            });
          this.handleCloseImport();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper {
    width: 678px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px 108px;
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
.lottery-top {
  width: 100%;
  height: 23px;
  display: flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  margin-bottom: 20px;
  div {
    margin-right: 50px;
  }
}
.lottery-time {
  width: 370px !important;
}
.el-tag {
  font-size: 14px;
  font-weight: 400;
  width: auto !important;
  min-width: 80px !important;
}
.el-tag.el-tag--purple {
  background-color: rgba(114, 46, 209, 0.1);
  border-color: rgba(114, 46, 209, 0.7);
  color: #722ed1;
}
.el-tag.el-tag--blue {
  background-color: rgba(24, 144, 255, 0.1);
  border-color: rgba(24, 144, 255, 0.7);
  color: #1890ff;
}
.el-tag.el-tag--yellow {
  background-color: rgba(234, 153, 33, 0.1);
  border-color: rgba(234, 153, 33, 0.7);
  color: #ea9921;
}

.el-tag.el-tag--red {
  background-color: rgba(220, 0, 25, 0.1);
  border-color: rgba(220, 0, 25, 0.7);
  color: #dc0019;
}
.el-tag.el-tag--end {
  background-color: rgba(73, 73, 73, 0.1);
  border-color: rgba(155, 155, 155, 0.7);
  color: #9b9b9b;
}
.el-tag.el-tag--gray {
  background-color: rgba(73, 73, 73, 0.2);
  border-color: rgba(155, 155, 155, 0.7);
  color: #9b9b9b;
}

.activity-table {
  .red {
    color: red;
  }
}
</style>
